var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicPorcentageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 11,
    viewBox: "0 0 40 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6377,
    cy: 5.46143,
    r: 4.5,
    fill: "#294732",
    stroke: "#294732"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6377 5.46143H37.6377",
    stroke: "#294732",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicPorcentageIcon);
export default __webpack_public_path__ + "static/media/GraphicPorcentageIcon.cc16683ffea4678c5dd26b1344715df2.svg";
export { ForwardRef as ReactComponent };